import { ChatListDataInterface } from '../components/chat/ChatListItemsMobile';
import { ChatList, ChatListActions } from '../model/index';

export function chatList(chatList: ChatListDataInterface[] | []): ChatListActions {
	return {
		type: ChatList.CHAT_LIST,
		payload: chatList,
	};
}
